<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <refresh-item :show="showRefreshItem" @onRefresh="fetchInitialData"></refresh-item>

    <stage-comment-item v-if="!showRefreshItem"></stage-comment-item>

    <div v-if="showUI" class="margin_top_20">
      <div class="margin-left-10 margin-right-10">
        <weex-text v-html="uploadInstructions"></weex-text>
      </div>

      <file-attach-button
        class="horizontal_center margin_top_40"
        size="medium"
        file-attach-button-id="upload_nach"
        text="Upload NACH"
        :attach-image-des-src="documentAttachImage"
        :enabled-text-style="attachFileButtonTextStyle"
        :enabled-btn-style="attachFileButtonStyle"
        @filesAttached="onNACHAttached"
      ></file-attach-button>

      <wxc-button
        text="Next"
        class="margin-top-40 margin-bottom-20 horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import RefreshItem from "../layout/RefreshItem";
import StageCommentItem from "../layout/StageCommentItem";
import { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import FileAttachButton from "../layout/FileAttachButton";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import AlertService from "../core/alert/AlertService";
import { EntityType } from "../../utils/EntityType";
import { Constants } from "../Constants";

const UPLOAD_NACH = "Please upload NACH/Mandate Form";
const DOCUMENT_UPLOADED = "Document uploaded successfully";

export default {
  name: "NachCollectionActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    RefreshItem,
    StageCommentItem,
    FileAttachButton,
    WxcButton
  },

  data: () => ({
    title: "NACH Collection",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    nachUploaded: false,
    showUI: false,
    uploadInstruction: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onNACHAttached(e) {
      const file = e.files[0];
      this.loading = true;
      DataSource.createDocument(
        EntityType.LOANS,
        LoanScopeDataHolder.getLoanId(),
        Constants.NACH_SIGNED_UNFILLED_NAME,
        Constants.getDescription(Constants.NACH_SIGNED_UNFILLED_NAME),
        Constants.NACH_SIGNED_UNFILLED_DIRECTORY,
        file
      )
        .then(createDocumentRes => {
          this.loading = false;
          if (createDocumentRes.errorOccurred) {
            this.showError(createDocumentRes.data);
          } else {
            this.nachUploaded = true;
            this.showToast(DOCUMENT_UPLOADED);
          }
        })
    },

    onSubmit() {
      if (this.checkForValidation()) {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    checkForValidation() {
      if (!this.nachUploaded) {
        this.showToast(UPLOAD_NACH);
        return false;
      }

      return true;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            const configData = stageConfigDataRes.data;
            this.uploadInstruction = configData && configData.properties
              ? configData.properties["stage.instructions"]
              : "";
            this.showUI = true;
          }
        })
    },
  },

  created() {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.NACH_COLLECTION];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    documentAttachImage() {
      return this.nachUploaded
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    attachFileButtonTextStyle() {
      return { color: "#ffffff" };
    },

    attachFileButtonStyle() {
      return {
        "background-color": "#f87246",
        "border-width": "1px",
        "border-style": "solid",
        "border-color": "gray"
      };
    },

    uploadInstructions() {
      const uploadInstructions = this.uploadInstruction ? this.uploadInstruction.split("\n") : [];
      let uploadInstruction = "<html><ul>";
      uploadInstructions.forEach(uploadInstructionItem => {
        uploadInstruction = `${uploadInstruction}<li style="margin-top: 5px; font-size: 16px; color: black;">${uploadInstructionItem}</li>`;
      });
      uploadInstruction = `${uploadInstruction}</ul></html>`;
      return uploadInstruction;
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

